import { useSelector } from 'react-redux'

import {
  isAdminOrOwnerSelector,
  isGroupAdminSelector,
} from 'selectors/current_user'

import { isUserProfilesFeatureAvailableSelector } from '../selectors'

export const useIsUserProfileViewable = () => {
  const isUserProfilesBillingFeatureAvailable = useSelector(isUserProfilesFeatureAvailableSelector)
  const isAdminOrOwner = useSelector(isAdminOrOwnerSelector)
  const isGroupAdmin = useSelector(isGroupAdminSelector)

  return isUserProfilesBillingFeatureAvailable ? (isAdminOrOwner || isGroupAdmin) : false
}
